module.exports = __webpack_public_path__ + "static/media/SupreethRao.963c08e2.svg";